<template>
  <el-form-item :prop="this.valueKey" class="box-wrap">
    <el-button type="primary" plain @click="addApprover">{{ $t('746') }}</el-button>
    <!-- 已选列表 -->
    <Person @empty="onEmpty" @remove="removeEle" :persons="nodeUserList" />
    <!-- 组织架构 -->
    <framework
      v-if="approverVisible"
      :defaultDepatment="[]"
      :defaultEmployess="nodeUserList"
      :visible.sync="approverVisible"
      @onConfirm="sureApprover"
      :control="control"
    />
  </el-form-item>
</template>

<script>
import framework from '_c/framework'
import Person from './person'
import { getStaffInfoByUserids } from 'api/common'

export default {
  components: { Person, framework },
  props: {
    // 原对象
    nodeData: {
      default: () => ({}),
      type: Object
    },
    // 默认要原对象修改的值
    valueKey: {
      default: 'val',
      type: String
    },
    control: {
      type: Object,
      default: () => ({
        all: 0,
        depShow: 2,
        staffShow: 1
      })
    }
  },
  data() {
    return {
      // 选人组件是否展示
      approverVisible: false,
      // 已选列表
      nodeUserList: []
    }
  },
  created() {
    this.init()
  },
  methods: {
    // 获取已选员工
    async init() {
      const val = this.nodeData[this.valueKey]
      if (Array.isArray(val)) {
        const staffIds = val.map(item => item.id || '')
        if (!val.length) return false
        const res = await getStaffInfoByUserids({ staff_ids: staffIds })
        this.nodeUserList = res.data.staff_list
      }
    },
    addApprover() {
      this.approverVisible = true
    },
    /**
     * 删除单个选中项
     * @param { number } index 下标
     */
    removeEle(index) {
      this.nodeUserList.splice(index, 1)
      this.onSave(this.nodeUserList)
    },
    onEmpty() {
      this.nodeUserList = []
      this.nodeData[this.valueKey] = []
    },
    /**
     * 存储已选项
     * @param { Array } staffList 员工列表
     */
    onSave(staffList) {
      this.nodeData[this.valueKey] = staffList.map(item => ({
        id: item.staff_id,
        label: item.staff_name
      }))
    },
    /**
     * 人员选择确认
     * @param {*} params 已选项
     */
    sureApprover(params) {
      // 添加到选中列表
      this.nodeUserList = params.staff_list
      this.onSave(params.staff_list)
      this.approverVisible = false
    }
  }
}
</script>
